// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0caa75ed","455":"dc7640cb","977":"8d865aa4"}[chunkId] + ".chunk.js";
};